import { render, staticRenderFns } from "./SingleTicketUser.vue?vue&type=template&id=3c0f8e6e&scoped=true"
import script from "./SingleTicketUser.vue?vue&type=script&lang=js"
export * from "./SingleTicketUser.vue?vue&type=script&lang=js"
import style0 from "./SingleTicketUser.vue?vue&type=style&index=0&id=3c0f8e6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0f8e6e",
  null
  
)

export default component.exports